.emptyState {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-top: 90px;
    padding-left: 16px;
    padding-right: 16px;
    gap: 12px;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    background-color: white;
    border-radius: 0 12px 12px 0;
}

.emptyStateVideo {
    width: 72px;
    height: 72px;
    object-fit: contain;
    pointer-events: none;

    &::-webkit-media-controls,
    &::-webkit-media-controls-enclosure,
    &::-webkit-media-controls-panel {
        display: none !important;
    }
}

.emptyStateText {
    color: #98a2b3;
    font-family: 'Hanken Grotesk', sans-serif;
    font-size: 15px;
    font-weight: 500;
}
